module.exports = __webpack_public_path__ + "static/media/xx-net.da0f3235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/xx-net.png
// module id = 217
// module chunks = 0